(() => {
  if (customElements.get('quick-shop')) {
    return;
  }

  class QuickShop extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents(); 
    }

    init() {
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.variantId = this.querySelector('[name="id"]').value;
      this.productCard = this.closest('[data-product-grid]');
    }

    attachEvents() {
      this.submitButton?.addEventListener('click', this.addToCart.bind(this));
    }
    
    addToCart(event) {
      event.preventDefault();

      this.submitButton.classList.add('is-loading');
  
      const item = {
        id: this.variantId,
        quantity: 1
      };

      fetch(`${theme.routes.cartAdd}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'items': [item] })
      }).then((response) => response.json())
        .then((response) => {
          if (response.status) {
            alert(response.description);
            return;
          }

          this.submitButton.classList.remove('is-loading');
          this.submitButton.classList.add('is-finished');
          
          window.monster_refresh(false);

        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.submitButton.classList.remove('is-loading');
            this.submitButton.classList.remove('is-finished');
          }, 2000);
        });
    }
  }

  customElements.define('quick-shop', QuickShop);
})();
